import { Slider, Typography } from "@mui/material";
import { AppCheckbox, LabelWithIcon } from "../../../../components/form";
import FlexBox from "../../../../components/layouts/Flexbox";
import { APP_COLORS } from "../../../../enums";
import { AwsIcon } from "../../../../assets/images";

interface EnvironmentListItemProps {
  item: { label: string; color?: string };
  value: number;
  onChange: (value: number) => void;
}

export default function EnvironmentListItem({
  item,
  value,
  onChange,
}: EnvironmentListItemProps) {
  const numericValue = Number(value) || 0;
  const checked = numericValue > 0;

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked ? numericValue || 0 : 0);
  };

  const handleSliderChange = (
    _event: Event,
    newValue: number | number[]
  ) => {
    onChange(Number(newValue));
  };

  return (
    <FlexBox gap={2} alignItems="center">
      <AppCheckbox
        label={
          <LabelWithIcon
            labelProps={{
              fontSize: "14px",
              color: APP_COLORS.textSecondary,
            }}
            label={item.label}
            icon={<img src={AwsIcon} height={20} width={20} alt={item.label} />}
          />
        }
        onChange={handleCheckboxChange}
        checkboxProps={{
          color: "primary",
          checked,
        }}
        rootProps={{ sx: { minWidth: "150px" } }}
      />

      <Slider
        component="div"
        value={numericValue}
        sx={{ height: 9 }}
        step={5}
        min={0}
        max={100}
        valueLabelDisplay="off"
        onChange={handleSliderChange}
      />
      <Typography variant="standard">{`${numericValue}%`}</Typography>
    </FlexBox>
  );
}
